export default "__VITE_ASSET__DP73FwwU__"